export const EXSBINVOICETYPE_DELETE_RESET = 'EXSBINVOICETYPE_DELETE_RESET'
export const EXSBINVOICETYPE_DELETE_SET_ERROR = 'EXSBINVOICETYPE_DELETE_SET_ERROR'
export const EXSBINVOICETYPE_DELETE_SET_DELETED = 'EXSBINVOICETYPE_DELETE_SET_DELETED'
export const EXSBINVOICETYPE_DELETE_TOGGLE_LOADING = 'EXSBINVOICETYPE_DELETE_TOGGLE_LOADING'
